export default __webpack_public_path__ + "assets/a4.0933d72d.jpg";